import BaseService from '../../services/BaseService';

class NotFoundService extends BaseService {
    get404NotFound = (data) => this.post(`/not-found`, data || { });
}

export default new NotFoundService();
